import React, { ReactNode } from 'react';

import { languageSelector } from '@redux/language';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';

import { FR_LOCALE, EN_LOCALE, ES_LOCALE } from 'constants/locales';
import { isB2bEnvironment } from 'services/helpers/featureToggle';
import { flattenMessages } from 'services/i18n/intl';
import enMessagesB2b from 'translations/b2b/en.json';
import esMessagesB2b from 'translations/b2b/es.json';
import frMessagesB2b from 'translations/b2b/fr.json';
import enMessagesB2c from 'translations/b2c/en.json';
import frMessagesB2c from 'translations/b2c/fr.json';
import enMessagesShared from 'translations/shared/en.json';
import esMessagesShared from 'translations/shared/es.json';
import frMessagesShared from 'translations/shared/fr.json';

const isB2b = isB2bEnvironment();

export const messages = {
  [FR_LOCALE]: flattenMessages({ ...frMessagesShared, ...(isB2b ? frMessagesB2b : frMessagesB2c) }),
  [EN_LOCALE]: flattenMessages({ ...enMessagesShared, ...(isB2b ? enMessagesB2b : enMessagesB2c) }),
  [ES_LOCALE]: flattenMessages({ ...esMessagesShared, ...(isB2b ? esMessagesB2b : enMessagesB2c) }),
};

interface Iinternationalization {
  locale: string;
  children: ReactNode;
}

const Internationalization: React.FC<Iinternationalization> = ({ locale, children }) => {
  const language = useSelector(languageSelector);
  return (
    <IntlProvider locale={locale} messages={messages[language]}>
      {children}
    </IntlProvider>
  );
};

export default Internationalization;
